import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { EstadoRevisionPublicacionDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class EstadoRevisionPublicacionService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getEstadoRevisionPublicacionService(): Observable<BodyListResponse<EstadoRevisionPublicacionDTO>> {
    return this.http.get<BodyListResponse<EstadoRevisionPublicacionDTO>>(API_URL + '/api/v1/estadoRevisionPublicacion/todos');
  }

  guardarEstadoRevisionPublicacionService(estadoRevisionPublicacionDTO: EstadoRevisionPublicacionDTO): Observable<BodyResponse<EstadoRevisionPublicacionDTO>> {
    return this.http.post<BodyResponse<EstadoRevisionPublicacionDTO>>(API_URL + '/api/v1/estadoRevisionPublicacion', estadoRevisionPublicacionDTO);
  }

  getEstadoRevisionPublicacionPorCodigoEstadoRevisionPublicacionService(codigoEstadoRevisionPublicacion: string): Observable<BodyResponse<EstadoRevisionPublicacionDTO>> {
    return this.http.get<BodyResponse<EstadoRevisionPublicacionDTO>>(API_URL + '/api/v1/estadoRevisionPublicacion/' + codigoEstadoRevisionPublicacion);
  }

  getEstadoRevisionPublicacionPorCodigoPersonaService(codigoPersona: string): Observable<BodyListResponse<EstadoRevisionPublicacionDTO>> {
    return this.http.get<BodyListResponse<EstadoRevisionPublicacionDTO>>(API_URL + '/api/v1/estadoRevisionPublicacion/persona/' + codigoPersona);
  }

}
